import { useAccountId } from '../../ContextProviders/CurrentAccount'
import { AccountType, type CaseloadInfo } from '../../core/types'
import { useAuth } from '../../hooks/use-auth'
import { usePermissions } from '../../hooks/use-permissions'
import { type ModalAction } from './CareManagementEdit'
import { ActionItem } from '../Menu/ActionItem'
import { ActionMenu } from '../Menu/ActionMenu'
import { Box } from '@mui/material'

export function CaseloadAssignmentActions (props: {
  caseloadInfo: CaseloadInfo | null
  onActionTaken: (action: ModalAction) => void
  onRemoveOrg: (isOther: boolean) => void
  viewHistory: () => void
  isShown: boolean
  onHide: () => void
  onShow: () => void
}): JSX.Element {
  const auth = useAuth()
  const perms = usePermissions()
  const account = useAccountId()
  const accountid = account?.type === AccountType.ISD ? null : account?.id ?? 0
  const hasOrgCareManagement = perms.CareNetwork_CareManagement
  const isSelfOrg = props.caseloadInfo?.orgId === accountid || account?.type === 'ISD'
  const isSelf = props.caseloadInfo?.userId === auth.user?.id

  const assignMe = (): void => {
    props.onActionTaken({
      actionType: 'AssignToMyCaseload',
      orgId: accountid,
      text: 'This action will add this child to your organization\'s caseload. Do you wish to continue?',
      title: 'Assign to My Caseload',
      userId: auth.user?.id ?? null,
      visible: true
    })
  }
  const assignUser = (): void => {
    props.onActionTaken({
      actionType: 'AssignToUserCaseload',
      orgId: accountid,
      text: 'This action will add this child to both your organization\'s caseload and the selected user\'s. Do you wish to continue?',
      title: 'Assign to User\'s Caseload',
      userId: null,
      visible: true
    })
  }
  const assignOrg = (): void => {
    props.onActionTaken({
      actionType: 'AssignToOrganizationCaseload',
      orgId: accountid,
      text: 'This action will add this child to your organization\'s caseload. Do you wish to continue?',
      title: 'Assign to Organization Caseload',
      userId: null,
      visible: true
    })
  }
  const removeUser = (): void => {
    props.onActionTaken({
      actionType: 'RemoveFromUserCaseload',
      orgId: accountid,
      text: `This action will remove this child from ${isSelf ? 'your' : (props.caseloadInfo?.userName ?? '')}'s caseload.  Do you wish to continue?`,
      title: `Remove from ${isSelf ? 'my' : (props.caseloadInfo?.userName ?? '')} Caseload`,
      userId: null,
      visible: true
    })
  }
  const removeMyOrg = (): void => {
    props.onRemoveOrg(false)
  }
  const viewHistory = async (): Promise<void> => {
    props.viewHistory()
  }

  const assignSelfItem = <ActionItem testId='actionAssignMy' onClick={assignMe} >Assign to my Caseload</ActionItem>
  const assignOtherItem = <ActionItem testId='actionAssignUser' onClick={assignUser} >Assign to User's Caseload</ActionItem>
  const assignToOrgItem = <ActionItem testId='actionAssignOrg' onClick={assignOrg} >Assign to Organization Caseload</ActionItem>
  const removeFromUserItem = <ActionItem testId='actionRemoveUser' onClick={removeUser} >{`Remove from ${isSelf ? 'my' : (props.caseloadInfo?.userName ?? 'User') + '\'s'} Caseload`}</ActionItem>
  const removeFromMyOrgItem = <ActionItem testId='actionRemoveOrg' onClick={removeMyOrg} >End Care Management</ActionItem>
  const viewHistoryItem = <ActionItem testId='actionViewHistory' onClick={viewHistory} >View Caseload History</ActionItem>

  const items = (props.caseloadInfo?.orgId == null || isSelfOrg) && (<>
    {!isSelf && assignSelfItem}
    {hasOrgCareManagement && assignOtherItem}
    {props.caseloadInfo?.orgId == null && hasOrgCareManagement && assignToOrgItem}
    {props.caseloadInfo?.orgId != null && hasOrgCareManagement && removeFromMyOrgItem}
    {hasOrgCareManagement && viewHistoryItem}
    {props.caseloadInfo?.userId != null && hasOrgCareManagement && removeFromUserItem}
  </>)
  return <ActionMenu open={props.isShown} onClose={props.onHide} onShow={props.onShow} testId='caseManagement' menuProps={{ border: 'none' }}>
    <Box>
      {items}
    </Box>
  </ActionMenu>
}
